import type { CitThemeColorScheme, CitThemeId } from '@cloudintellitech/ui'
import {
  CIT_THEME_IDS,
  DEFAULT_CIT_THEME_ID,
  getCitThemePreviewVariable,
  isCitThemeId,
} from '@cloudintellitech/ui'

export const CIT_UI_MANAGED_THEMES = CIT_THEME_IDS

export type CitUiColorScheme = CitThemeColorScheme

type ThemeAttributeTarget = Pick<Element, 'removeAttribute' | 'setAttribute'>

export function isCitUiManagedTheme(themeName: string): themeName is CitThemeId {
  return isCitThemeId(themeName)
}

export function getThemePreviewColor(
  themeName: string,
  colorScheme: CitUiColorScheme,
) {
  const themeId = isCitUiManagedTheme(themeName) ? themeName : DEFAULT_CIT_THEME_ID
  return getCitThemePreviewVariable(themeId, colorScheme)
}

export function syncCitUiThemeAttributes(
  target: ThemeAttributeTarget,
  themeName: string,
  colorScheme: CitUiColorScheme,
) {
  const themeId = isCitUiManagedTheme(themeName) ? themeName : DEFAULT_CIT_THEME_ID
  target.setAttribute('data-cit-theme', themeId)
  target.setAttribute('data-cit-color-scheme', colorScheme)
}
